import type { LoggerAdapter } from "@/shared/logger/types";

export const consoleAdapter: LoggerAdapter = {
  log: ({ level, message, context }) => {
    // biome-ignore lint/suspicious/noConsole: this is the console adapter
    console[level](message, context ?? "");
  },
};
